export const SALE_ANALYSIS_PAGE_UUID = 'b8d03182-dc8b-462a-a5e2-7cfdc4a5ed04'
